import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap"
import { IoHomeOutline } from "react-icons/io5"
import Select from "react-select";
import { AllUsers, GetAllManagerUsers } from "../../utils/proxy/Authproxy";
import DataTable from "react-data-table-component";
import { GetTpAchievements } from "../../utils/proxy/ChartsProxy";
import { RiFileExcel2Fill } from "react-icons/ri";
import { Parser } from "@json2csv/plainjs";
import { GetDoctorDpDetails } from "../../utils/proxy/Doctorproxy";
import { GetHospitalDpDetails } from "../../utils/proxy/Hospitalsproxy";
import { GetClinicDpDetails } from "../../utils/proxy/Clinicproxy";
import { GetChemistDpDetails } from "../../utils/proxy/Chemistproxy";
import { GetStockistDpDetails } from "../../utils/proxy/Stockistproxy";
import { GetAllUserTeritoryDetailsByIds } from "../../utils/proxy/Userteritoryproxy";
import { GetAllHolidaysByYearAndMonth } from "../../utils/proxy/AttendanceProxy";
import { Op_per } from "../../utils/Permissions";
import LoadingComponent from "../Includes/LoadingComponent"

export const TpAchievements = () => {

    const months = [
        { label: "January", value: "01" },
        { label: "February", value: "02" },
        { label: "March", value: "03" },
        { label: "April", value: "04" },
        { label: "May", value: "05" },
        { label: "June", value: "06" },
        { label: "July", value: "07" },
        { label: "August", value: "08" },
        { label: "September", value: "09" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" },
    ];

    const currentYear = new Date().getFullYear();
    const years = [];

    for (let i = currentYear; i >= currentYear - 100; i--) {
        years.push({ value: i.toString(), label: i.toString() });
    }

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [userid, setUserId] = useState(localStorage.getItem('role') === 'User' ? localStorage.getItem('uuid') : null);
    const [selectedUser, setSelectedUser] = useState();
    const [users, setUsers] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()]); // Set the default month to '01'
    const [selectedYear, setSelectedYear] = useState(years[0]);
    const [reload, setReload] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dpData, setDpData] = useState([]);
    const [attendanceDetails, setAttendanceDetails] = useState({fieldwork:0,holiday:0,weeklyoff:0,leaves:0,totaldates:0});
    const [callDetails, setCallDetails] = useState({totalDoctorMet:0,totalHospitalMet:0,totalChemistMet:0,totalClinicMet:0,totalStockistMet:0,totalCipMet:0});
    
    const [uniqueTerritoryCoverage, setUniqueTerritoryCoverage] = useState([]);

    useEffect(() => {
    if (!data || data.length === 0) {
        setUniqueTerritoryCoverage([]);
        return;
    }

    const areaDetails = new Map();

    data.forEach(entry => {
        const hqMap = entry.hqMap || {};
        Object.entries(hqMap).forEach(([code, type]) => {
        if (!areaDetails.has(code)) {
            areaDetails.set(code, { id: code, type, count: 0 });
        }
        areaDetails.get(code).count += 1;
        });
    });

    const ids = Array.from(areaDetails.keys());

    GetAllUserTeritoryDetailsByIds(ids).then((result) => {
        // result should be array of objects with territory info, like name, id, etc.
        const mergedData = result.map((territory) => {
        const localData = areaDetails.get(territory.id.toString());
        
        return {
            id: territory.id,
            name: territory.areaname || territory.areaname || 'N/A',
            type: localData?.type || 'N/A',
            totalVisit: localData?.count || 0
        };
        });

        setUniqueTerritoryCoverage(mergedData);
    });
    }, [data]);

    useEffect(() => {
        // Fetch data from an API when the component mounts
        const getallusers = async () => {
            if (localStorage.getItem('role') === 'Admin') {
                let allusers = await AllUsers();
                setUsers(allusers);
            } else if (localStorage.getItem('role') === 'Manager') {
                let allusers = await GetAllManagerUsers(localStorage.getItem('uuid'));
                setUsers(allusers);
            }
        };
        getallusers();
    }, []);

    useEffect(() => {
        // Fetch data from an API when the component mounts
        const getallteritories = async (userid, selectedMonth, selectedYear) => {
             setLoading(true);
            let userteritories = await GetTpAchievements(
                userid,
                selectedMonth,
                selectedYear
            );
            setLoading(false);
            if (userteritories) {
                setData(userteritories);
                setAttendanceDetails({fieldwork:0,holiday:0,weeklyoff:0,leaves:0,totaldates:0});
                setCallDetails({totalDoctorMet:0,totalHospitalMet:0,totalChemistMet:0,totalClinicMet:0,totalStockistMet:0,totalCipMet:0});
                setAttendanceDetails(prevAttendance => ({
                    ...prevAttendance,
                    totaldates: userteritories.length
                  }));
                userteritories.map(data=>{
                    if (data.worked === 'Field Work' ) {
                        setAttendanceDetails(prevAttendance => ({
                            ...prevAttendance,
                            fieldwork: prevAttendance.fieldwork + 1
                          }));
                    }
                    
                    if(data.worked === 'Leave' ){
                        setAttendanceDetails(prevAttendance => ({
                            ...prevAttendance,
                            leaves: prevAttendance.leaves + 1
                          }));
                    }

                    if(data.aspertp === 'Weekly Off' && data.worked !== 'Field Work' ){
                        setAttendanceDetails(prevAttendance => ({
                            ...prevAttendance,
                            weeklyoff: prevAttendance.weeklyoff + 1
                          }));
                    }
                    
                    if(data.worktype.toLowerCase() !== 'working' && data.aspertp.toLowerCase() !== 'working' && data.aspertp.toLowerCase() !== 'leave' && data.aspertp.toLowerCase() !== 'weekly off' ){
                        setAttendanceDetails(prevAttendance => ({
                            ...prevAttendance,
                            holiday: prevAttendance.holiday + 1
                          }));
                    }

                    setCallDetails(detail =>({
                        ...detail,
                        totalClinicMet:detail.totalClinicMet+data.clinics_met,
                        totalHospitalMet:detail.totalHospitalMet+data.hospitals_met,
                        totalDoctorMet:detail.totalDoctorMet+data.doctors_met,
                        totalStockistMet:detail.totalStockistMet+data.stockists_met,
                        totalChemistMet:detail.totalChemistMet+data.chemist_met,
                        totalCipMet:detail.totalCipMet+data.cip_met,
                    }))
                })
            } else {
                alert("Error", "Issue While Fetching Tour Plan");
            }
        };
        if (userid && selectedMonth.value && selectedYear.value) {
            getallteritories(userid, selectedMonth.value, selectedYear.value);
        }
        setReload(false);
    }, [reload, userid, selectedMonth, selectedYear]);

    const handleSelectChange = (selected) => {
        setUserId(selected.value);
        setSelectedUser(selected)
    };

    const handleSelectChangeMOnth = (selected) => {
        setSelectedMonth(selected);
    };

    const handleSelectChangeYear = (selected) => {

        setSelectedYear(selected);
    };

    const options = [];

    users.map((user) => {
        options.push({
            value: user.userid,
            label: user.username + "(" + user.firstname + " " + user.lastname + ")",
        });
    });

    const handleDpClick = async (date, userid, type, dpdata) => {
        if (dpdata != 0) {
            if (type === 'doctor') {
                let d = await GetDoctorDpDetails(userid, date);
                setDpData(d);
                setShowModal(true);
            } else if (type === 'hospital') {
                let d = await GetHospitalDpDetails(userid, date);
                setDpData(d);
                setShowModal(true);
            } else if (type === 'chemist') {
                let d = await GetChemistDpDetails(userid, date);
                setDpData(d);
                setShowModal(true);
            } else if (type === 'clinic') {
                let d = await GetClinicDpDetails(userid, date);
                setDpData(d);
                setShowModal(true);
            } else if (type === 'stockist') {
                let d = await GetStockistDpDetails(userid, date);
                setDpData(d);
                setShowModal(true);
            }else if(type === "HQ"){
                const ids = Object.keys(userid).map(String);
                let d = await GetAllUserTeritoryDetailsByIds(ids);
                const cleanedTerritories = d.map(({ id, country_id, areaid, userid,countrycode, ...rest }) => rest);
                setDpData(cleanedTerritories);
                setShowModal(true); 

            }
        }
    }

const handleholidayclick = async () => {
    try {
        console.log('selectedUser', selectedUser)
        let d = await GetAllHolidaysByYearAndMonth(selectedYear.value, selectedMonth.value,selectedUser.value);
        if (d && d.length > 0) {
            setDpData(d);
            setShowModal(true);
        }
    } catch (error) {
        console.error("Error fetching holidays:", error);
    }
};

    const columns = [
        {
            name: "Date",
            selector: (row) => row.date,
            margin: 30,
            width: "8%",
        },
        {
            name: "Work Type",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.worktype === "" || row.worktype === null ? "#f36e6f" : "", borderRadius: "10px", border: row.worktype === "" || row.worktype === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.worktype === "" || row.worktype === null ? "#fff" : "#000", margin: "3px", }}>{row.worktype ? row.worktype : "N/A"}</div>,
            width: "10%",

        },
        {
            name: "As Per Tp",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === "" || row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === null ? "#f36e6f" : "", borderRadius: "10px", border: row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === "" || row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === "" || row.aspertp == "" ? "N/A" : row.aspertp + " " + row.aspertp === null ? "#fff" : "#000", margin: "3px", }}>{row.aspertp == "" ? "N/A" : row.aspertp}</div>,
            width: "10%",
        },
        {
            name: "Worked",
            selector: (row) =>   <div style={{ whiteSpace: 'normal', backgroundColor: row.worked == "" ? "N/A" : row.worked + " " + row.worked === "" || row.worked == "" ? "N/A" : row.worked + " " + row.worked === null ? "#f36e6f" : "", borderRadius: "10px", border: row.worked == "" ? "N/A" : row.worked + " " + row.worked === "" || row.worked == "" ? "N/A" : row.worked + " " + row.worked === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.worked == "" ? "N/A" : row.worked + " " + row.worked === "" || row.worked == "" ? "N/A" : row.worked + " " + row.worked === null ? "#fff" : "#000", margin: "3px", }}>{row.worked == "" ? "N/A" : row.worked}</div>,
            width: "10%",
        },
        {
            name: <p>Doctors Met</p>,
            selector: (row) => <span style={{color: row.doctors_met && row.doctors_met > 0 ? "blue" : "black",cursor:row.doctors_met && row.doctors_met > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, userid, 'doctor', row.doctors_met)}>{row.doctors_met}</span>,
            // <div style={{ whiteSpace: 'normal',backgroundColor: row.unplanned_doctor=== "" || row.unplanned_doctor=== null ? "#f36e6f":"", borderRadius:"10px", border: row.unplanned_doctor=== "" || row.unplanned_doctor=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.unplanned_doctor=== "" || row.unplanned_doctor=== null ? "#fff": "#000", margin:"3px", }}>{row.unplanned_doctor? row.unplanned_doctor: "N/A"}</div> ,
            width: "8%",
        },
        {
            name: <p>Clinics Met</p>,
            selector: (row) => <span style={{color: row.clinics_met && row.clinics_met > 0 ? "blue" : "black",cursor:row.clinics_met && row.clinics_met > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, userid, 'clinic', row.clinics_met)}>{row.clinics_met}</span>,

            // <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_clinic=== "" || row.planned_clinic=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_clinic=== "" || row.planned_clinic=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_clinic=== "" || row.planned_clinic=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_clinic? row.planned_clinic: "N/A"}</div>,
            width: "8%",
        },
        {
            name: <p>Chemist Met</p>,
            selector: (row) => <span style={{color: row.chemist_met && row.chemist_met > 0 ? "blue" : "black",cursor:row.chemist_met && row.chemist_met > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, userid, 'chemist', row.chemist_met)}>{row.chemist_met}</span>,
            // <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_chemist=== "" || row.planned_chemist=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_chemist=== "" || row.planned_chemist=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_chemist=== "" || row.planned_chemist=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_chemist? row.planned_chemist: "N/A"}</div> ,
            width: "8%",
        },
        {
            name: <p>Stockist Met</p>,
            selector: (row) => <span style={{color: row.stockists_met && row.stockists_met > 0 ? "blue" : "black",cursor:row.stockists_met && row.stockists_met > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, userid, 'stockist', row.stockists_met)}>{row.stockists_met}</span>,
            //  <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_stockist=== "" || row.planned_stockist=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_stockist=== "" || row.planned_stockist=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_stockist=== "" || row.planned_stockist=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_stockist? row.planned_stockist: "N/A"}</div>  ,
            width: "8%",
        },
        {
            name: <p>Hospital Met</p>,
            selector: (row) => <span style={{color: row.hospitals_met && row.hospitals_met > 0 ? "blue" : "black",cursor:row.hospitals_met && row.hospitals_met > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, userid, 'hospital', row.hospitals_met)}>{row.hospitals_met}</span>,
            //  <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_hospital=== "" || row.planned_hospital=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_hospital=== "" || row.planned_hospital=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_hospital=== "" || row.planned_hospital=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_hospital? row.planned_hospital: "N/A"}</div> ,
            width: "8%",
        },
        {
            name: <p>Cip Met</p>,
            selector: (row) => <span >{row.cip_met}</span>,
            //  <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_hospital=== "" || row.planned_hospital=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_hospital=== "" || row.planned_hospital=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_hospital=== "" || row.planned_hospital=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_hospital? row.planned_hospital: "N/A"}</div> ,
            width: "8%",
        },
                {
            name: <p>Coverage</p>,
            selector: (row) => <span style={{color: Object.values(row.hqMap).length && Object.values(row.hqMap).length > 0 ? "blue" : "black",cursor:Object.values(row.hqMap).length && Object.values(row.hqMap).length > 0 ? "pointer" :""}} onClick={() => handleDpClick(row.date, row.hqMap, 'HQ', row.hqMap)}>{Object.values(row.hqMap).length}</span>,
            //  <div style={{ whiteSpace: 'normal',backgroundColor: row.planned_hospital=== "" || row.planned_hospital=== null ? "#f36e6f":"", borderRadius:"10px", border: row.planned_hospital=== "" || row.planned_hospital=== null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.planned_hospital=== "" || row.planned_hospital=== null ? "#fff": "#000", margin:"3px", }}>{row.planned_hospital? row.planned_hospital: "N/A"}</div> ,
            width: "10%",
        },
    ];

    const conditionalRowStyles = [
        {
            when: row => row.aspertp == "Holiday",
            style: {
                backgroundColor: 'rgb(245, 185, 0,0.9)',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
        },
        {
            when: row => row.aspertp == "Not Submitted",
            style: {
                backgroundColor: '#ff0000ab',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
        },
    ]


async function downloadCSV(plans, attendanceDetails, callDetails, uniqueTerritoryCoverage) {
    let csv;
    try {
        const opts = {
            fields: [
                { label: "Date", value: "date" },
                { label: "Work Type", value: "worktype" },
                { label: "As Per Tp", value: "aspertp" },
                { label: "Worked", value: "worked" },
                { label: "Doctors Met", value: "doctors_met" },
                { label: "Clinics Met", value: "clinics_met" },
                { label: "Chemists Met", value: "chemist_met" },
                { label: "Stockists Met", value: "stockists_met" },
                { label: "Hospitals Met", value: "hospitals_met" },
                { label: "Cip Met", value: "cip_met" },
            ],
        };
        const parser = new Parser(opts);
        csv = parser.parse(plans); // <- Fixed this line
    } catch (err) {
        console.error("CSV Parsing Error:", err);
        return;
    }

    if (!csv) return;

    const attendanceDetailsCsv = [
        "",
        "Attendance Details",
        "Field Work" + attendanceDetails.fieldwork,
        "Holiday" + attendanceDetails.holiday,
        "Weekly Off" + attendanceDetails.weeklyoff,
        "Leaves" + attendanceDetails.leaves,
        "Total Days" + attendanceDetails.totaldates,
    ].join('\n');

    const territoryCoverageCsv = [
        "",
        "Territory Coverage",
        "Territory Name,Territory Type,Total Visit",
        ...uniqueTerritoryCoverage.map(t => `${t.name},${t.type},${t.totalVisit}`)
    ].join('\n');

    const fw = attendanceDetails.fieldwork || 0;

    const callDetailCsv = [
        "",
        "Call Details",
        `Doctor Met,${callDetails.totalDoctorMet}`,
        `Doctor Call Average,${fw ? (callDetails.totalDoctorMet / fw).toFixed(2) : 0}`,
        `Chemist Met,${callDetails.totalChemistMet}`,
        `Chemist Call Average,${fw ? (callDetails.totalChemistMet / fw).toFixed(2) : 0}`,
        `Hospital Met,${callDetails.totalHospitalMet}`,
        `Hospital Call Average,${fw ? (callDetails.totalHospitalMet / fw).toFixed(2) : 0}`,
        `Stockist Met,${callDetails.totalStockistMet}`,
        `Stockist Call Average,${fw ? (callDetails.totalStockistMet / fw).toFixed(2) : 0}`,
        `Clinic Met,${callDetails.totalClinicMet}`,
        `Clinic Call Average,${fw ? (callDetails.totalClinicMet / fw).toFixed(2) : 0}`,
        `Cip Met,${callDetails.totalCipMet}`,
        `Cip Call Average,${fw ? (callDetails.totalCipMet / fw).toFixed(2) : 0}`,
    ].join('\n');

    const month = months.find(m => m.value === selectedMonth.value);
    const filename = `TpVsAchievement[${selectedUser.label}]-${month.label}-${selectedYear.value}.csv`;

    // Compose final CSV content
    const fullCsv = [
        `Tp Vs Achievement Report for ${month.label} ${selectedYear.value} of ${selectedUser.label}`,
        '',
        csv,
        attendanceDetailsCsv,
        territoryCoverageCsv,
        callDetailCsv
    ].join('\n\n');

    // Trigger file download
    const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(fullCsv);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link); // Needed for Firefox
    link.click();
    document.body.removeChild(link);
}


    const Export = ({ onExport }) => (
        <Button style={{ position: 'absolute', right: 40, backgroundColor: "#2194f0",display:Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.ALLOW_EXPORT_XLSX ? '' : 'none' }} onClick={(e) => onExport(e.target.value)} disabled={!(userid && selectedMonth.value && selectedYear.value)}><RiFileExcel2Fill /></Button>
    );

    const actionsMemo = React.useMemo(
        () => <Export onExport={() => downloadCSV(data,attendanceDetails,callDetails,uniqueTerritoryCoverage)} />,
        [[data, attendanceDetails, callDetails, uniqueTerritoryCoverage]]
    );

    return (
        <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                            
                        /></a></li>
                        <li><a href="/tp-achievement"><span class="icon icon-beaker"> </span>Reports</a></li>

                        <li><a href="#"><span class="icon icon-double-angle-right"></span>Tp Vs Achievements</a></li>

                    </ul>

                </div>

            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                    }}
                    className="flex-column-mobile"
                >
                    <div style={{ width: "250px", display:Op_per.get().REPORTS_TP_VS_ACHIEVEMENT.USER_DROPDOWN ? '' : 'none' }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">Users</Form.Label>
                            <div className="w-75">
                                <Select
                                    className="selectdoctor"
                                    options={options}
                                    value={selectedUser}
                                    onChange={handleSelectChange}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div style={{ width: "250px" }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">Select Month</Form.Label>
                            <div className="w-50">
                                <Select
                                    className="selectdoctor"
                                    options={months}
                                    value={selectedMonth}
                                    onChange={handleSelectChangeMOnth}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div style={{ width: "250px" }}>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <Form.Label className="mt-2">Select Year</Form.Label>
                            <div className="w-50">
                                <Select
                                    className="selectdoctor"
                                    options={years}
                                    value={selectedYear}
                                    onChange={handleSelectChangeYear}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                </div>
                {/* Loader */}
                {loading && (
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 100 }}>
                    <LoadingComponent />
                    </div>
                )}
                {!loading && (<>
                <div className="pt-3">
                    <DataTable
                        columns={columns}
                        data={data}
                        conditionalRowStyles={conditionalRowStyles}
                        actions={actionsMemo}
                        pagination
                        customStyles={{ headRow: { style: { backgroundColor: '#c0dfff', padding: 7 }, } }}
                        style={{ margin: '10px', padding: 10 }}
                        dense
                    />
                </div>

                {data.length > 0 ? <div style={{display:'flex', justifyContent:'space-evenly', alignItems:'flex-start'}}>
                <table className="table" style={{margin:5}} border={1}>
                    <thead style={{fontWeight:'bold'}}>
                        <tr>
                            <td>Attendance Details</td>
                            <td>Total</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Field Work</td>
                            <td>{attendanceDetails.fieldwork}</td>
                            <td></td>
                        </tr>
                        <tr onClick={()=>{if(attendanceDetails.holiday !== 0)handleholidayclick()}} style={{cursor: attendanceDetails.holiday !== 0 ? 'pointer' : ""}}>
                            <td>Holiday</td>
                            <td>{attendanceDetails.holiday}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Weekly off</td>
                            <td>{attendanceDetails.weeklyoff}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Leaves</td>
                            <td>{attendanceDetails.leaves}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Total No Of Days</td>
                            <td>{attendanceDetails.totaldates}</td>
                            <td></td>
                        </tr>
                    </tbody>

                    <thead style={{fontWeight:'bold'}}>
                        <tr>
                            <td>Territory Name</td>
                            <td>Territory type</td>
                            <td>Total Visit</td>
                        </tr>
                    </thead>
                    <tbody>
                        {uniqueTerritoryCoverage.map((territory) => (
                            <tr key={territory.id}>
                                <td>{territory.name}</td>
                                <td>{territory.type}</td>
                                <td>{territory.totalVisit}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <table className="table" style={{margin:5}} border={1}>
                    <thead style={{fontWeight:'bold'}}>
                        <tr>
                            <td>Call Details</td>
                            <td>Total</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Total Doctors Met</td>
                            <td>{callDetails.totalDoctorMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Doctor</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalDoctorMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                        <tr>
                            <td>Total Chemist Met</td>
                            <td>{callDetails.totalChemistMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Chemist</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalChemistMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                        <tr>
                            <td>Total Hospitals Met</td>
                            <td>{callDetails.totalHospitalMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Hospital</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalHospitalMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                        <tr>
                            <td>Total Stockist Met</td>
                            <td>{callDetails.totalStockistMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Stockist</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalStockistMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                        <tr>
                            <td>Total Clinics Met</td>
                            <td>{callDetails.totalClinicMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Clinic</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalClinicMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                        <tr>
                            <td>Total Cip Met</td>
                            <td>{callDetails.totalCipMet}</td>
                        </tr>
                        <tr>
                            <td>Call Average Of Cip</td>
                            <td>{attendanceDetails.fieldwork!= 0 ? (callDetails.totalCipMet / attendanceDetails.fieldwork).toFixed(2) : 0}</td>
                        </tr>
                    </tbody>
                </table>
                </div> : null}
                  </>
                  )}                      
            </div>
            

            <Modal size="lg" style={{height:'80%',overflow:'auto'}} show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Body>
                    <div style={{height:'390px',scrollbarWidth:'thin'}} className="overflow-auto">
                        {dpData.length > 0 && <table className="table">
                            <thead>
                                <tr>
                                    {Object.entries(dpData[0]).map(([key,value]) => (
                                        <th style={{border:'1px solid black'}}>{key}</th>
                                        ))}
                                </tr>
                            </thead>
                                        {dpData.map((obj)=>(
                            <tbody>
                                <tr>
                                    {Object.values(obj).map((value, index) => (
                                        <td style={{border:'1px solid black'}} key={index}>{value ?? '--'}</td>
                                    ))}
                                </tr>
                            </tbody>
                    ))}
                        </table>}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShowModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </Container>
    )
}